import type { ReactNode } from 'react'
import { cn } from '../../lib/utils'

/**
 * KA-52 — **Beschäftigungsanzeige der KI**: drei springende Punkte, davor der Text der Stelle („Die KI
 * liest die Rechnung"). Steht überall, wo ein Aufruf an die KI läuft — auf einem Knopf, in einer Zeile
 * oder als eigener Hinweis. Eine Stelle für ERP und PWA (seit AP-46 H), damit die Anzeige überall gleich
 * aussieht (`.claude/rules/ki-beschaeftigungsanzeige.md`).
 *
 * Die Punkte ersetzen die Auslassungspunkte: Der Text kommt **ohne** „…". Farbe und Größe folgen der
 * Schrift der Stelle. Wer Bewegung im Betriebssystem abgeschaltet hat, sieht die Punkte pulsieren statt
 * springen. Die Animation `ki-punkt` steht in der Tailwind-Konfiguration beider Apps.
 */
export function KiArbeitet({ text, className }: { text?: ReactNode; className?: string }) {
  return (
    <span role="status" aria-label={text ? undefined : 'Die KI arbeitet'} className={cn('inline-flex items-baseline gap-[0.3em]', className)}>
      {text && <span>{text}</span>}
      <span aria-hidden className="inline-flex shrink-0 items-baseline gap-[0.18em]">
        {[0, 1, 2].map((i) => (
          <span key={i} className="inline-block h-[0.3em] w-[0.3em] rounded-full bg-current motion-safe:animate-ki-punkt motion-reduce:animate-pulse" style={{ animationDelay: `${i * 0.15}s` }} />
        ))}
      </span>
    </span>
  )
}
